var __rspack_ns_object = JSON.parse('{"Clear dates":"Daten löschen","End Date":"Enddatum","Start Date":"Startdatum"}')